<template>
    <div class="container">
        <div class="header">
            <div class="swiper-banner">
                <div class="swiper-wrapper">
                    <div class="swiper-slide slide-item1">
                        <img
                            src="../assets/img/sign/banner1.png"
                            alt=""
                        >
                    </div>
                    <div class="swiper-slide slide-item2">
                        <img
                            src="../assets/img/sign/banner2.png"
                            alt=""
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-1">
            <div class="btn-content flex btn-1">
                <div class="title">
                    拉 勾 教 育 学 习 计 划 在 线 领 取
                </div>
                <a @click="gotoJump">
                    <img
                        src="../assets/img/sign/title-1-btn.png"
                        alt=""
                        class="title-btn animate-btn"
                    >
                </a>
            </div>
            <div class="des-content">
                <div class="des">
                    互联网为什么要选择大数据
                </div>
                <div class="tips">
                    5G时代，大数据势不可挡
                </div>
            </div>
            <div class="detail-content flex">
                <img
                    src="../assets/img/sign/section-1-child1.png"
                    alt=""
                    class="detail-item"
                >
                <div class="space" />
                <img
                    src="../assets/img/sign/section-2-child2.png"
                    alt=""
                    class="detail-item"
                >
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    查看拉勾大数据开发就业详情
                </button>
            </div>
        </div>
        <div class="section section-2">
            <div class="des-content">
                <div class="des">
                    拉勾6大优势 一站式解决学习痛难点
                </div>
            </div>
            <div class="detail-content solution">
                <div
                    v-for="(item,index) in lazyUrlList.solutionList"
                    :key="index"
                    class="detail-item animate-btn"
                    :class="{'last':(index+1)%3===0}"
                >
                    <img
                        v-lazy="item"
                        alt=""
                        class="solution-icon"
                    >
                    <div class="title">
                        {{ solutionObj[index].title }}
                    </div>
                    <div class="title-des">
                        {{ solutionObj[index].desc }}
                    </div>
                </div>
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    在线答疑
                </button>
            </div>
            <div class="path-bg1" />
            <div class="path-bg2" />
        </div>
        <div class="section section-3">
            <div class="des-content">
                <div class="des">
                    大数据+拉勾体系化知识架构  满足企业用人需求
                </div>
                <div class="tips">
                    5G时代，大数据势不可挡
                </div>
            </div>
            <div class="detail-content flex">
                <img
                    src="../assets/img/sign/section-3.png"
                    alt=""
                    class="detail-item"
                >
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    成长路线在线咨询
                </button>
            </div>
        </div>
        <div class="section section-4">
            <div class="des-content">
                <div class="des">
                    14阶段知识体系助你吃透大数据开发
                </div>
            </div>
            <div class="detail-content">
                <div class="stage-list clearfix">
                    <div
                        v-for="(item, index) in stageList"
                        :key="index"
                        :class="{'stage-list-item-last': (index + 1) % 3 === 0, 'hover': index === current}"
                        class="stage-list-item"
                        @mouseenter.stop="e => handleMouseEnter(e, index)"
                        @mouseleave.stop="handleMouseLeave"
                    >
                        <img
                            v-lazy="lazyUrlList.stageList[index]"
                            alt=""
                            class="stage-list-item-icon"
                        >
                        <div class="stage-list-item-title">
                            {{ item.desc }}
                            <div class="sub-title">
                                {{ item.title }}
                            </div>
                        </div>
                        <ul class="stage-list-item-list">
                            <li
                                v-for="(detailItem, contentIndex) in item.detail"
                                :key="contentIndex"
                                class="detail-content-item"
                            >
                                {{ detailItem.title }}
                            </li>
                        </ul>
                    </div>
                    <div
                        v-show="showPop"
                        :style="{left: 0, top: popY + 'PX'}"
                        class="stage-pop"
                        @mouseenter="handleEnterPop"
                        @mouseleave="handleMouseLeave"
                    >
                        <div
                            v-if="leftStageList.length"
                            class="stage-pop-left"
                        >
                            <div
                                v-for="(item, index) in leftStageList"
                                :key="index"
                                class="stage-pop-item clearfix"
                            >
                                <div class="item-title">
                                    {{ item.title }}
                                </div>
                                <ul
                                    class="item-desc"
                                >
                                    <li
                                        v-for="(t, idx) in item.content"
                                        :key="idx"
                                    >
                                        {{ t }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            v-if="rightStageList.length"
                            class="stage-pop-right"
                        >
                            <div
                                v-for="(item, index) in rightStageList"
                                :key="index"
                                class="stage-pop-item clearfix"
                            >
                                <div class="item-title">
                                    {{ item.title }}
                                </div>
                                <ul
                                    class="item-desc"
                                >
                                    <li
                                        v-for="(t, idx) in item.content"
                                        :key="idx"
                                    >
                                        {{ t }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            :style="{left: `${triangleX}px`}"
                            class="triangle"
                        />
                    </div>
                </div>
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    领取完整大纲
                </button>
            </div>
        </div>
        <div class="section section-5">
            <div class="des-content">
                <div class="des">
                    深入实战项目  积累一手开发经验
                </div>
            </div>
            <div class="detail-content">
                <div
                    ref="swiper"
                    class="swiper-container"
                >
                    <div class="swiper-wrapper">
                        <div
                            v-for="item in swiperList"
                            :key="item.url"
                            class="swiper-slide"
                        >
                            <img
                                :src="item.url"
                                :alt="item.title"
                            >
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    更多实战项目咨询
                </button>
            </div>
        </div>
        <div class="section section-6">
            <div class="des-content">
                <div class="des">
                    拉勾独家内推服务  务实求职每一步
                </div>
                <div class="tips">
                    优秀学员可享内推
                </div>
            </div>
            <div class="detail-content">
                <ul class="service-list">
                    <img
                        v-lazy="lazyUrlList.lineUrl"
                        alt=""
                        class="service-line"
                    >
                    <li
                        v-for="(item,index) in lazyUrlList.serviceList"
                        :key="index"
                        class="service-item flex"
                        :class="{'double':index%2===1}"
                    >
                        <div class="left">
                            <img
                                v-lazy="item.url"
                                alt=""
                            >
                            <span class="service-title">{{ '0'+(index+1) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.title }}</span>
                        </div>
                        <div class="right">
                            {{ item.des }}
                        </div>
                    </li>
                </ul>
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    立即咨询
                </button>
            </div>
        </div>
        <div class="section section-7">
            <div class="des-content">
                <div class="des">
                    8大复合场景学习方式 让学习变得轻松
                </div>
                <div class="tips">
                    复合场景学习方式  全方位辅助学习
                </div>
            </div>
            <div class="detail-content">
                <ul class="study-list">
                    <li
                        v-for="(item,index) in studyList"
                        :key="index"
                        class="study-item"
                        :class="{'last':(index+1)%4 === 0}"
                    >
                        <div class="study-title">
                            {{ item.title }}
                        </div>
                        <div class="study-content flex">
                            {{ item.des }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="section section-8">
            <div class="des-content">
                <div class="des">
                    签订保障就业协议
                </div>
                <div class="tips">
                    拉勾求职绿色通道，直通一线互联网公司面试官
                </div>
            </div>
            <div class="detail-content">
                <img
                    src="../assets/img/sign/agreement.png"
                    alt=""
                >
                <div class="agreement-detail">
                    <div class="agreement-des">
                        <span class="leftdes">
                            支 持 信 用 卡 分 期
                        </span>
                        <span class="rightdes">
                            手 续 费 0 利息
                        </span>
                    </div>
                    <div class="agreement-tips">
                        轻松入学 帮你减轻负担
                    </div>
                </div>
            </div>
            <div class="common-btn-content">
                <button
                    class="common-btn animate-btn"
                    @click="toApply"
                >
                    获取企业内推名额
                </button>
            </div>
        </div>
        <a
            class="fixed-bar fixed-bar-show"
            @click="gotoJump"
        >
            <!-- 详细【学习计划】和专业老师【1V1求职指导】
            <img
                src="../assets/img/sign/title-1-btn.png"
                alt=""
                class="animate-btn"
            > -->
        </a>
        <!-- 侧边导航栏 -->
        <LaunchNav :active-tab="1" />
    </div>
</template>

<script>
import common from './common';
import { footerCom } from '../../../uitl/618.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import LaunchNav from '../../../components/LaunchNav/index';

let timer = null;
let popTimer = null;
export default {
    name: 'SignIn',
    components: {
        LaunchNav
    },
    mixins: [common, footerCom],
    data() {
        return {
            // 秒
            countDownTime: 0,
            countText: '',
            showPop: false,
            popY: 0,
            current: -1,
            // 控制显示底部的固定条
            showFixedBar: false,
            triangleX: 0,
            modify: 1,
            swiperList: [
                { title: '项目1', url: require('../assets/img/sign/slide-img-1.png') },
                { title: '项目2', url: require('../assets/img/sign/slide-img-2.png') },
                { title: '项目3', url: require('../assets/img/sign/slide-img-3.png') },
            ],
            lazyUrlList: {
                fixedBar: require('../assets/img/sign/fixed-bar.png'),
                lineUrl: require('../assets/img/sign/line.png'),
                serviceList: [
                    {
                        title: '真题解忧', des: 'BAT等一线大厂面试真题解析，务实面试基础', url: require('../assets/img/sign/service-bg.png'),
                    },
                    {
                        title: '简历优化', des: '扬长避短，让HR三秒记住你，提升简历通过率', url: require('../assets/img/sign/service-bg.png')
                    },
                    {
                        title: '面试模拟', des: '真实的面试流程模拟，查缺补漏，一举拿下面试', url: require('../assets/img/sign/service-bg.png')
                    },
                    {
                        title: '大厂内推', des: '70万+企业资源，简历直通TL，让offer不再难拿', url: require('../assets/img/sign/service-bg.png')
                    }

                ],
                solutionList: [
                    require('../assets/img/sign/solution-1.png'),
                    require('../assets/img/sign/solution-2.png'),
                    require('../assets/img/sign/solution-3.png'),
                    require('../assets/img/sign/solution-4.png'),
                    require('../assets/img/sign/solution-2.png'),
                    require('../assets/img/sign/solution-3.png')
                ],
                stageList: [
                    require('../assets/img/sign/part-1.png'),
                    require('../assets/img/sign/part-2.png'),
                    require('../assets/img/sign/part-3.png'),
                    require('../assets/img/sign/part-4.png'),
                    require('../assets/img/sign/part-5.png'),
                    require('../assets/img/sign/part-6.png'),
                    require('../assets/img/sign/part-7.png'),
                    require('../assets/img/sign/part-8.png'),
                    require('../assets/img/sign/part-9.png'),
                    require('../assets/img/sign/part-10.png'),
                    require('../assets/img/sign/part-11.png'),
                    require('../assets/img/sign/part-12.png'),
                    require('../assets/img/sign/part-13.png'),
                    require('../assets/img/sign/part-14.png')
                ]
            },
            studyList: [
                { title: '线上学习', des: '突破时间、空间限制' },
                { title: '实践拓展', des: '大咖直播面对面' },
                { title: '陪伴学习', des: '班主任全程伴读' },
                { title: '源码开放', des: '项目代码免费送' },
                { title: '独家资料', des: '资料随堂提供' },
                { title: '定期测评', des: '专项突击式训练' },
                { title: '模拟面试', des: '直击面试重点' },
                { title: '大厂内推', des: '每月优秀学员直推大厂' },
            ],
            solutionObj: Object.freeze({
                0: {
                    title: 'PB级企业大数据中台落地实践',
                    desc: '手把手带你从0到1完整构建PB级大数据一体化处理、分析平台'
                },
                1: {
                    title: '企业千亿级数据真实案例驱动',
                    desc: '项目背景、需求、架构真实，涵养“数据大屏”、”人才用户画像“、“数据湖”等内容，让你拥有真实的开发经验'
                },
                2: {
                    title: '大数据架构思维培养',
                    desc: '架构思维培养贯穿各个项目案例，不仅让你具备扎实的开发能力，同时拥有高屋建瓴的架构视角'
                },
                3: {
                    title: '纵向深度突破',
                    desc: '开源组件底层原理及源码剖析（包含源码二次开发）让你拥有深度调优的能力'
                },
                4: {
                    title: '企业千亿级数据真实案例驱动',
                    desc: 'ClickHouse、Kudu、Kylin、Driud等前沿技术最新实践'
                },
                5: {
                    title: '大数据架构思维培养',
                    desc: '课程广度、深度兼备，实战性极强，学完即拥有1-3年大数据从业能力，带你成功转型提升'
                }
            })
        };
    },
    computed: {
        leftStageList() {
            if (this.current === -1) return [];
            return this.stageList[this.current].detail.filter((item, index) => index % 2 === 0);
        },
        rightStageList() {
            if (this.current === -1) return [];
            return this.stageList[this.current].detail.filter((item, index) => index % 2 !== 0);
        },
    },
    mounted() {
        const headerSwiper = new Swiper('.swiper-banner', {
            autoplay: 3000,
            loop: true,
            speed: 500,
        });
        this.swiperAds();
    },
    methods: {
        // 点击申请调客服
        toApply() {
            window.open('https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2');
        },
        swiperAds() {
            let modify = 0;
            let translate = 0;
            let scale = 0;
            const swiper = new Swiper('.swiper-container', {
            autoplay: 3000,
            loop: true,
            slidesPerView: 'auto',
            loopedSlides: 4,
            pagination: '.swiper-pagination',
            paginationClickable: true,
            watchSlidesProgress: true,
            centeredSlides: true,
            onSetTransition: (swiper, transition) => {
                for (let i = 0; i < swiper.slides.length; i++) {
                    let slide = swiper.slides.eq(i);
                    slide.transition(transition);
                }
            },
        });

        swiper.on('progress', () => {
            for (let i = 0; i < swiper.slides.length; i++) {
                let slide = swiper.slides.eq(i);
                let slideProgress = swiper.slides[i].progress;
                modify = 1;
                if (Math.abs(slideProgress) > 1) {
                    modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
                translate = slideProgress * modify * 379 + 'px';
                scale = 1 - Math.abs(slideProgress) / 5;
                let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                slide.css('zIndex', zIndex);
            }
        });
        },
        countDown() {
            this.countText = this.formatTime(this.countDownTime);
            if (this.countDownTime > 0) {
                timer = setTimeout(() => {
                    this.countDownTime--;
                    this.countDown();
                }, 1000);
            } else {
                clearTimeout(timer);
            }
        },
        handleMouseEnter(e, index) {
            clearTimeout(popTimer);
            this.showPop = true;
            this.current = index;
            const currentTarget = e.currentTarget;
            this.triangleX = currentTarget.offsetLeft + currentTarget.clientWidth / 2 - 14;
            this.popY = currentTarget.offsetTop + currentTarget.clientHeight + 15;
        },
        handleEnterPop() {
            clearTimeout(popTimer);
            this.showPop = true;
        },
        handleMouseLeave() {
            popTimer = setTimeout(() => {
                this.current = -1;
                this.showPop = false;
            }, 300);
        },
        gotoJump() {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qb3',
            //     'button_name': '领取详细课程大纲'
            // });
            handleJumpUrl(`d247297443df4df383f19cc13917fa1d`);
        },
    },
};
</script>

<style scoped lang="less">
@import './sign.less';
</style>
